import {
  MapPinContainer,
  MapPinHomeIcon,
  MapPinIconWrapper,
  NearbyPatientsCount,
} from "./AdvanceSearchMap.style";
import { getGroupPatientStatusColor } from "./AdvanceMapHelper";
import { useTranslation } from "hhn-commons";
import { INearbyPatient } from "@home-health-notify/domain";

export const NearbyPatientsPin = ({
  patients,
}: {
  patients: INearbyPatient[];
}) => {
  const { t } = useTranslation();
  const tNAdvanceSearch = (key: string) => t(key, { ns: "advanceSearch" });
  const patientsLength = patients.length;

  function displayPatientsLength(patientsLength: number) {
    if (patientsLength > 1 && patientsLength <= 100) {
      return patientsLength;
    } else if (patientsLength > 100) {
      return tNAdvanceSearch("patientsCountHundred");
    }
  }

  const patientStatusColor =
    patientsLength > 0 ? getGroupPatientStatusColor(patients) : undefined;

  return (
    <>
      {patientsLength > 0 && patientStatusColor && (
        <MapPinContainer
          statusColor={patientStatusColor.iconColor}
          borderColor={patientStatusColor.borderColor}
          data-testid="map-marker-icon"
        >
          <MapPinIconWrapper>
            {patientsLength === 1 && <MapPinHomeIcon />}
            {
              <NearbyPatientsCount>
                {displayPatientsLength(patientsLength)}
              </NearbyPatientsCount>
            }
          </MapPinIconWrapper>
        </MapPinContainer>
      )}
    </>
  );
};
